import { membersOfFacultyBreadcrumbs, membersOfFacultyRoutesObj } from "./path";

import { concatRoutesMetadata, createRoute } from "@/routes/utils";
import type { IPartialRouteMetadataObj } from "@/routes/types";
import { facultyMemberRouteMetadata } from "@routes/admin/usersManagement/facultyMembers/route";

const partialMembersOfFacultyRoutesMetadata: IPartialRouteMetadataObj<
  typeof membersOfFacultyRoutesObj
> = {
  list: {
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/facultyMembers/table/page"),
  },
  create: {
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/facultyMembers/form/page"),
  },
  edit: {
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/facultyMembers/form/page"),
  },
  view: {
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/facultyMembers/form/page"),
  },
};

const membersOfFacultyRoutesMetadata = concatRoutesMetadata<
  typeof membersOfFacultyRoutesObj
>(facultyMemberRouteMetadata, partialMembersOfFacultyRoutesMetadata);

export const membersOfFacultyRoutes = createRoute<
  typeof membersOfFacultyRoutesObj
>(
  membersOfFacultyRoutesObj,
  membersOfFacultyRoutesMetadata,
  membersOfFacultyBreadcrumbs,
);
